"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipExtensionDefinition = void 0;
const WidgetExtensionPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPlugin");
const WidgetExtensionPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPluginDefinition");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const configs_1 = require("../../configs/configs");
class TooltipExtension extends WidgetExtensionPlugin_1.default {
    constructor(definition, domHelper) {
        super(definition);
        this.domHelper = domHelper;
    }
    /**
     * @inheritDoc
     */
    static create(definition, container) {
        return new this(definition, container.get("dom_helper"));
    }
    /**
     * @inheritDoc
     */
    initialize(widget) {
        this.widget = widget;
        this.widget.getEventContainer()
            .on(WidgetEvents_1.WidgetEvents.STEP_READY, this.registerTooltipEvents.bind(this));
        return Promise.resolve();
    }
    /**
     * Registers tooltips and listeners on them for display.
     */
    registerTooltipEvents() {
        const tooltips = this.widget.getContainer().querySelectorAll(`[${configs_1.configs.dataAttribute.tooltipButton}]`);
        for (let i = 0, tooltipIcon; tooltipIcon = tooltips[i]; ++i) {
            tooltipIcon.addEventListener("mouseover", (event) => {
                const id = event.target.getAttribute(configs_1.configs.dataAttribute.tooltipButton);
                const tooltipContainer = this.widget.getContainer()
                    .querySelector(`[${configs_1.configs.dataAttribute.tooltipContainer}="${id}"]`);
                setTimeout(() => {
                    this.addTooltip(tooltipContainer, tooltipIcon);
                }, 50);
            });
            tooltipIcon.addEventListener("mouseout", (event) => {
                const id = event.target.getAttribute(configs_1.configs.dataAttribute.tooltipButton);
                const tooltipContainer = this.widget.getContainer()
                    .querySelector(`[${configs_1.configs.dataAttribute.tooltipContainer}="${id}"]`);
                setTimeout(() => {
                    this.removeTooltip(tooltipContainer);
                }, 50);
            });
            // For mobile, mostly.
            tooltipIcon.addEventListener("mousedown", (event) => {
                const id = event.target.getAttribute(configs_1.configs.dataAttribute.tooltipButton);
                const tooltipContainer = this.widget.getContainer()
                    .querySelector(`[${configs_1.configs.dataAttribute.tooltipContainer}="${id}"]`);
                setTimeout(() => {
                    tooltipContainer.classList.contains(configs_1.configs.utilityCSSClasses.activated) ?
                        this.removeTooltip(tooltipContainer) : this.addTooltip(tooltipContainer, tooltipIcon);
                }, 50);
            });
        }
    }
    /**
     * Displays tooltip.
     *
     * @param tooltipContainer
     * @param tooltipIcon
     */
    addTooltip(tooltipContainer, tooltipIcon) {
        if (tooltipContainer.classList.contains(configs_1.configs.utilityCSSClasses.activated)) {
            return;
        }
        tooltipContainer.classList.add(configs_1.configs.utilityCSSClasses.activated);
        const boxElement = tooltipContainer.children[0];
        const posContainer = boxElement.getBoundingClientRect();
        const posIcon = tooltipIcon.getBoundingClientRect();
        const alignIn = tooltipContainer.getAttribute(configs_1.configs.dataAttribute.tooltipContain);
        const alignInElement = alignIn ?
            this.widget.getContainer().querySelector(alignIn) :
            this.widget.getContainer();
        this.alignTooltipContainer(boxElement, posIcon, posContainer, alignInElement.getBoundingClientRect());
        const pointer = tooltipContainer.querySelector(`[${configs_1.configs.dataAttribute.tooltipPointer}]`);
        const pointerOver = tooltipContainer.querySelector(`[${configs_1.configs.dataAttribute.tooltipPointerOver}]`);
        if (pointer && pointerOver) {
            this.alignPointerArrow(pointer, posIcon, posContainer);
            this.alignPointerArrow(pointerOver, posIcon, posContainer);
        }
    }
    /**
     * Aligns tooltip to question icon and container.
     *
     * @param tooltip
     * @param iconPosition
     * @param containerPosition
     * @param containInPosition
     */
    alignTooltipContainer(tooltip, iconPosition, containerPosition, containInPosition) {
        const padding = 12;
        let translateX = 0;
        let translateY = Math.round((iconPosition.bottom + padding) - containerPosition.top);
        let width = containerPosition.width;
        if (containInPosition.width < width) {
            width = containInPosition.width;
        }
        if (containerPosition.left < containInPosition.left) {
            translateX = containerPosition.left - containInPosition.left;
        }
        if (containerPosition.right - (containerPosition.width - width) > containInPosition.right) {
            translateX = containInPosition.right - (containerPosition.right - (containerPosition.width - width));
        }
        if (width != containerPosition.width) {
            tooltip.style.width = `${width}px`;
            containerPosition.width = width;
        }
        tooltip.style.transform = `translate(${translateX}px, ${translateY}px)`;
    }
    /**
     * Aligns the pointer arrow to the question icon.
     *
     * @param pointer
     * @param toPosition
     * @param containerPosition
     */
    alignPointerArrow(pointer, toPosition, containerPosition) {
        const posPointer = pointer.getBoundingClientRect();
        let translate = (toPosition.left + toPosition.width / 2) - (posPointer.left + posPointer.width / 2);
        translate = Math.min(Math.max(0, translate), containerPosition.width - posPointer.width - 5);
        pointer.style.transform = `translateX(${translate}px)`;
    }
    /**
     * Hides tooltip.
     *
     * @param element
     */
    removeTooltip(element) {
        if (!element.classList.contains(configs_1.configs.utilityCSSClasses.activated)) {
            return;
        }
        element.classList.remove(configs_1.configs.utilityCSSClasses.activated);
        const pointer = element.querySelector(`[${configs_1.configs.dataAttribute.tooltipPointer}]`);
        const pointerOver = element.querySelector(`[${configs_1.configs.dataAttribute.tooltipPointerOver}]`);
        if (pointer && pointerOver) {
            pointer.style.transform = `translateX(0)`;
            pointerOver.style.transform = `translateX(0)`;
        }
        const boxElement = element.children[0];
        boxElement.style.transform = `translateY(0)`;
    }
}
exports.default = TooltipExtension;
Mixin_1.default(TooltipExtension, IContainerInjection_1.default);
exports.TooltipExtensionDefinition = new WidgetExtensionPluginDefinition_1.default({
    id: "tooltip",
    class: TooltipExtension
});
